import client from './client';

// ── Sections ────────────────────────────────────────────────────────────────

/** Получить список разделов */
export const getSections = () => client.get('/sections');

/** Создать раздел */
export const createSection = (payload) => client.post('/sections', payload);

/** Обновить раздел */
export const updateSection = (id, payload) => client.put(`/sections/${id}`, payload);

/** Удалить раздел */
export const deleteSection = (id) => client.delete(`/sections/${id}`);

// ── Exercise Types ───────────────────────────────────────────────────────────

/** Получить список типов упражнений */
export const getExerciseTypes = () => client.get('/exercises/types');

/** Создать тип упражнения */
export const createExerciseType = (payload) => client.post('/exercises/types', payload);

/** Обновить тип упражнения */
export const updateExerciseType = (id, payload) => client.put(`/exercises/types/${id}`, payload);

/** Удалить тип упражнения */
export const deleteExerciseType = (id) => client.delete(`/exercises/types/${id}`);

// ── Exercises (заголовки, без контент-полей) ─────────────────────────────────

/** Получить список упражнений */
export const getExercises = () => client.get('/exercises/');

/** Создать заголовок упражнения (name, description, type_id, complexity_level_id, task) */
export const createExercise = (payload) => client.post('/exercises/', payload);

/** Обновить заголовок упражнения */
export const updateExercise = (id, payload) => client.put(`/exercises/${id}`, payload);

/** Удалить упражнение */
export const deleteExercise = (id) => client.delete(`/exercises/${id}`);

// ── Exercise Variants ────────────────────────────────────────────────────────

/** Получить все варианты одного упражнения */
export const getVariants = (exerciseId) =>
  client.get(`/exercises/${exerciseId}/variants`);

/** Получить один вариант */
export const getVariant = (exerciseId, variantId) =>
  client.get(`/exercises/${exerciseId}/variants/${variantId}`);

/** Создать вариант */
export const createVariant = (exerciseId, payload) =>
  client.post(`/exercises/${exerciseId}/variants`, payload);

/** Обновить вариант */
export const updateVariant = (exerciseId, variantId, payload) =>
  client.put(`/exercises/${exerciseId}/variants/${variantId}`, payload);

/** Удалить вариант */
export const deleteVariant = (exerciseId, variantId) =>
  client.delete(`/exercises/${exerciseId}/variants/${variantId}`);

// ── Parse Text ───────────────────────────────────────────────────────────────

/**
 * Разобрать текст упражнения через AI/парсер.
 * @param {string} text - исходный текст
 * @param {number} typeId - ID типа упражнения
 * @param {number} exerciseId - ID упражнения (для сохранения варианта)
 * @param {string} [prompt] - опциональный промпт
 * @param {string} [generationPrompt] - промпт генерации
 * @param {number} [startFrom] - начать с позиции
 * @param {boolean} [useAiParser] - использовать AI парсер
 */
export const parseText = (text, typeId, exerciseId, prompt, generationPrompt, startFrom, useAiParser) => {
  const payload = { text, type_id: typeId };
  if (exerciseId) payload.exercise_id = exerciseId;
  if (prompt) payload.prompt = prompt;
  if (generationPrompt) payload.generation_prompt = generationPrompt;
  if (startFrom != null) payload.start_from = startFrom;
  if (useAiParser != null) payload.use_ai_parser = useAiParser;
  return client.post('/exercises/parse-text', payload);
};

/** Разобрать текст упражнения на лексику ([TEXT]/[WORDS] формат) */
export const parseLexicsText = (text) =>
  client.post('/exercises/parse-lexics', { text });

/** AI-подбор правильных ответов для лексики */
export const suggestLexicsAnswers = (question, blanks) =>
  client.post('/exercises/suggest-lexics-answers', { question, blanks });

// ── Prompts ──────────────────────────────────────────────────────────────────

/** Получить список промптов */
export const getPrompts = () => client.get('/exercises/prompts');

/** Создать промпт */
export const createPrompt = (payload) => client.post('/exercises/prompts', payload);

/** Удалить промпт */
export const deletePrompt = (id) => client.delete(`/exercises/prompts/${id}`);

/** Получить дефолтный промпт */
export const getDefaultPrompt = () => client.get('/exercises/default-prompt');

// ── Grammar Rules ────────────────────────────────────────────────────────────

/** Список всех правил */
export const getGrammarRules = () => client.get('/grammar-rules');

/** Правила по типу упражнения (нужные — первыми) */
export const getGrammarRulesByType = (typeId) =>
  client.get(`/grammar-rules/by-exercise-type/${typeId}`);

/** Создать правило */
export const createGrammarRule = (payload) => client.post('/grammar-rules/', payload);

/** Обновить правило */
export const updateGrammarRule = (id, payload) => client.put(`/grammar-rules/${id}`, payload);

/** Удалить правило */
export const deleteGrammarRule = (id) => client.delete(`/grammar-rules/${id}`);

/** Сгенерировать текст правила через AI */
export const generateGrammarRule = (payload) => client.post('/grammar-rules/generate', payload);

/** Привязать/отвязать правило к варианту */
export const linkGrammarRule = (exerciseId, variantId, grammarRuleId) =>
  client.patch(`/exercises/${exerciseId}/variants/${variantId}/grammar-rule`, {
    grammar_rule_id: grammarRuleId,
  });

// ── Complexity Levels ────────────────────────────────────────────────────────

/** Получить список уровней сложности */
export const getComplexityLevels = () => client.get('/complexity-levels/');

/** Создать уровень сложности */
export const createComplexityLevel = (data) => client.post('/complexity-levels/', data);

/** Обновить уровень сложности */
export const updateComplexityLevel = (id, data) => client.put(`/complexity-levels/${id}`, data);

/** Удалить уровень сложности */
export const deleteComplexityLevel = (id) => client.delete(`/complexity-levels/${id}`);
